export default function (text) {
    return `(${text})`;
}
